import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import { AuthProvider, TokenBridge } from './auth/AuthContext'
import { configureAmplify } from './auth/amplify'
import './styles.css'
import './workspace.css'

configureAmplify()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <TokenBridge />
        <App />
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>,
)
